export const $ = jQuery.noConflict();

export const executeScroll = (offset, duration) => {
	if (offset && duration) {
		$('html, body').animate({
			scrollTop: `${offset}px`
		}, duration);
	}
}

export const stripHash = url => {
	const hashPosition = url.indexOf('/#');
	
	if (hashPosition === -1) {
		return url;
	}
	return url.slice(0, hashPosition + 1);
}

export const getHash = url => {
	const hashPosition = url.indexOf('/#');

	if (hashPosition === -1) {
		return false;
	}
	return url.slice(hashPosition + 1, url.length)
}

export const getTargetOffset = href => {
	const target = $(href);

	console.log(target.length);
	return target.length ? target.offset().top : null;
}

export const toObject = string => {
	const object = string.split(',').reduce((acc, cur) => {
		let data = cur.split(':');
		acc[data[0]] = data[1];
		return acc;
	}, {});

	return object;
}


// WEBPACK FOOTER //
// ./assets/js/src/helpers.js